import { useState } from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import Logo from "../logo/Logo";
import Links from "../../links/Links";
import { useAuthContext } from "../../context/AuthContext";

function Navbar({ mainBlogData }) {
  const { user } = useAuthContext();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="nav">
      <div className="navLeft">
        <Link to="/" className="navlogo">
          <Logo
            brandName={mainBlogData?.Logo?.url}
            location="footer"
            cl="logo-img"
          />
        </Link>
      </div>

      <div className={`navCenter ${menuOpen ? "mobileShow" : ""}`}>
        <Links cl={""} />
      </div>

      <div className="navRight">
        {/* Hamburger icon for mobile */}
        <div className="menuIcon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <i className="fa-solid fa-xmark"></i>
          ) : (
            <i className="fa-solid fa-bars"></i>
          )}
        </div>

        {user ? (
          <Link className="link" to="/profile">
            <img
              className="navImg"
              src={process.env.REACT_APP_UPLOAD_URL + user.profilePic?.url}
              alt="User Avatar"
            />
          </Link>
        ) : (
          ""
          // <ul className="navList">
          //   <li className="navListItem">
          //     <Link className="link" to="/login">
          //       LOGIN
          //     </Link>
          //   </li>
          //   <li className="navListItem">
          //     <Link className="link" to="/register">
          //       REGISTER
          //     </Link>
          //   </li>
          // </ul>
        )}
      </div>
    </div>
  );
}

export default Navbar;
